import customDataProvider from "./customDataProvider";

export interface IGetUserAuthInfoRequest {
	user: string; // or any other type
}

const dataProvider = customDataProvider(process.env.REACT_APP_API_BASE_URL || '');

export default dataProvider;
